import { render, staticRenderFns } from "./CompTrafficCard.vue?vue&type=template&id=375a0b46&scoped=true"
import script from "./CompTrafficCard.vue?vue&type=script&lang=js"
export * from "./CompTrafficCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a0b46",
  null
  
)

export default component.exports